import { CardImage } from "./CardImage";
import { CardRoot } from "./CardRoot";
import { CardTitle } from "./CardTitle";

export const Card = {
  Root: CardRoot,
  CardImage: CardImage,
  CardTitle: CardTitle  
}